import { render, staticRenderFns } from "./ConfiguracaoBalanca.vue?vue&type=template&id=b69f5c3a&scoped=true"
import script from "./ConfiguracaoBalanca.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoBalanca.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracaoBalanca.vue?vue&type=style&index=0&id=b69f5c3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b69f5c3a",
  null
  
)

export default component.exports